<script setup>
import TopBar from "~/components/organisms/TopBar.vue";
import Header from "~/components/organisms/Header.vue";
import FooterBlock from "~/components/organisms/FooterBlock.vue";
import GreyBlock from "~/components/templates/GreyBlock.vue";
import SideMenu from '~/components/organisms/SideMenu.vue'
import {useCartStore} from "~/store/cartStore.js";

const cartStore = useCartStore();

onMounted(() => {
  preloadSideMenu()
  preloadOnIdle(() => preloadQuotation())
  cartStore.getContent()
})

useHead({
  meta: [
    {name: 'robots', content: 'index, follow'}
  ],
})
</script>

<template>
  <div class="main-layout">
    <GreyBlock :padding="0">
      <div class="g-32">
        <header>
          <TopBar/>
          <Header mode="clean"/>
        </header>
        <SideMenu/>
        <main>
          <div class="g-128">
            <slot/>
          </div>
        </main>
      </div>
    </GreyBlock>
    <FooterBlock/>
  </div>
</template>

<style scoped lang="scss">
main {
  @include smd {
    padding: 0;
  }
}
</style>
